export const enum onboardingConstants {
  inviteUserRequest = 'ONBOARDING_INVITE_USER_REQUEST',
  inviteUserSuccess = 'ONBOARDING_INVITE_USER_SUCCESS',
  inviteUserFailure = 'ONBOARDING_INVITE_USER_FAILURE',

  signupRequest = 'ONBOARDING_SIGNUP_REQUEST',
  signupSuccess = 'ONBOARDING_SIGNUP_SUCCESS',
  signupFailure = 'ONBOARDING_SIGNUP_FAILURE',

  verifyKycRequest = 'ONBOARDING_VERIFY_KYC_REQUEST',
  verifyKycSuccess = 'ONBOARDING_VERIFY_KYC_SUCCESS',
  verifyKycFailure = 'ONBOARDING_VERIFY_KYC_FAILURE',

  referralDecisionRequest = 'ONBOARDING_REFERRAL_DECISION_REQUEST',
  referralDecisionSuccess = 'ONBOARDING_REFERRAL_DECISION_SUCCESS',
  referralDecisionFailure = 'ONBOARDING_REFERRAL_DECISION_FAILURE',
  
  fetchReferralsRequest = 'ONBOARDING_FETCH_REFERRALS_REQUEST',
  fetchReferralsSuccess = 'ONBOARDING_FETCH_REFERRALS_SUCCESS',
  fetchReferralsFailure = 'ONBOARDING_FETCH_REFERRALS_FAILURE',
  
  fetchUserDetailsRequest = 'ONBOARDING_FETCH_USER_DETAILS_REQUEST',
  fetchUserDetailsSuccess = 'ONBOARDING_FETCH_USER_DETAILS_SUCCESS',
  fetchUserDetailsFailure = 'ONBOARDING_FETCH_USER_DETAILS_FAILURE',
  
  processDecisionRequest = 'ONBOARDING_PROCESS_DECISION_REQUEST',
  processDecisionSuccess = 'ONBOARDING_PROCESS_DECISION_SUCCESS',
  processDecisionFailure = 'ONBOARDING_PROCESS_DECISION_FAILURE',
  processDecisionReset = 'ONBOARDING_PROCESS_DECISION_RESET',
  
  resubmitApplicationRequest = 'ONBOARDING_RESUBMIT_APPLICATION_REQUEST',
  resubmitApplicationSuccess = 'ONBOARDING_RESUBMIT_APPLICATION_SUCCESS',
  resubmitApplicationFailure = 'ONBOARDING_RESUBMIT_APPLICATION_FAILURE',
  resubmitApplicationReset = 'ONBOARDING_RESUBMIT_APPLICATION_RESET',
  
  fetchDraftRequest = 'ONBOARDING_FETCH_DRAFT_REQUEST',
  fetchDraftSuccess = 'ONBOARDING_FETCH_DRAFT_SUCCESS',
  fetchDraftFailure = 'ONBOARDING_FETCH_DRAFT_FAILURE',
  
  saveDraft = 'ONBOARDING_SAVE_DRAFT',
}
